import '../../lib/ng-password-strength.min.js'
import PasswordResetController from './PasswordResetController'
import PasswordResetService from './PasswordResetService'
import Reset from './Reset'
import angular from 'angular'
import ngMessages from 'angular-messages'
import register from '../util/register'

var passwordReset = angular.module(
  'app.passwordReset', ['ngMessages', 'ngPasswordStrength']
)

register('app.passwordReset')
  .factory('Reset', Reset.factory)
  .service('PasswordResetService', PasswordResetService)
  .controller('PasswordResetController', PasswordResetController)

passwordReset.run()
